<nz-badge nzStandalone [nzCount]="iconTemplate" class="good-state"></nz-badge>
<ng-template #iconTemplate>
    <dpqa-icon iconName="check" [iconSize]="2" />
</ng-template>
